import styled from '@emotion/styled'

export const PaymentMethodsContent = styled.div`
  border: 1px solid #eceff2;
  border-radius: 16px;

  .yuno-payment-list__radiogroup {
    padding: 0;
  }

  .yuno-payment-list__radio {
    padding: 24px;
    background: transparent;
  }

  .yuno-skeleton-form:not(:only-child) {
    display: none;
  }
`

export const ButtonExternalContent = styled.div``
